import React, { useState, useEffect, useRef } from 'react';
import { IoPrintSharp } from "react-icons/io5";
import { Button } from 'react-bootstrap';
import html2pdf from 'html2pdf.js';
import { GrDocumentPdf } from "react-icons/gr";
import axios from "axios";
import { toWords } from 'number-to-words';
import logopdf from '../assets/img/logopdf.png';
import headerImage from '../../src/assets/img/header.png';
import footerImage from '../../src/assets/img/footer.png';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong, FaPlus } from "react-icons/fa6";
const Table = () => {
  const printRef = useRef();
  const navigate = useNavigate();
  const [data, setViewData] = useState({});
  const [companyDetails, setCompanyDetails] = useState({});
  const token = localStorage.getItem("token");
  const orderProductId = localStorage.getItem("orderproduct_id_pdf");
  const [totalQty, setTotalQty] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [loadingList, setLoadingList] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalPriceInWords, setTotalPriceInWords] = useState('');
  const [cgstAmount, setCgstAmount] = useState(0);
  const [sgstAmount, setSgstAmount] = useState(0);
  const [totalGst, setTotalGst] = useState(0);

  useEffect(() => {
    const fetchOrderData = async () => {
      setLoadingList(true);
      try {
        const url = `${process.env.REACT_APP_API_URL}Order-view-product-list/${orderProductId}`;
        const response = await axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
        });
        const { createOrder, product, product_other_data, extra_charges_store } = response.data.rows;

        const orderDetails = createOrder[0];
        const totalQty = product.reduce((acc, prod) => acc + parseFloat(prod.qty), 0);
        const totalPrice = product.reduce((acc, prod) => acc + (prod.price * prod.qty), 0);
        const formattedDescription = orderDetails.description
          ? orderDetails.description.replace(/\n/g, '<br/>')
          : "No description available.";

        const cgstAmount = (totalPrice * orderDetails.c_gst) / 100;
        const sgstAmount = (totalPrice * orderDetails.s_gst) / 100;
        const totalGst = cgstAmount + sgstAmount;

        setTotalQty(totalQty);
        setTotalPrice(totalPrice);
        setCgstAmount(cgstAmount);
        setSgstAmount(sgstAmount);
        setTotalGst(totalGst);
        setViewData({
          ...orderDetails,
          products: product,
          otherData: product_other_data[0] || [],
          description: formattedDescription,
          other_charges_total: orderDetails.other_charges_total || 0,
          extrCharges: extra_charges_store
        });
      } catch (error) {
        console.error("There was a problem fetching data:", error);
      } finally {
        setLoadingList(false);
      }
    };

    fetchOrderData();
  }, [token, orderProductId]);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}Company-details-list`, {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
        });
        if (response.data.status === 1) {
          setCompanyDetails(response.data.data[0]);
        }
      } catch (error) {
        console.error('Error fetching company details:', error);
      }
    };

    fetchCompanyDetails();
  }, [token]);

  useEffect(() => {
    const calculatedTotalAmount = parseFloat(totalPrice || 0)
      + parseFloat(data.other_charges_total || 0)
      + parseFloat(cgstAmount || 0)
      + parseFloat(sgstAmount || 0);
    setTotalAmount(calculatedTotalAmount);
    setTotalPriceInWords(toWords(calculatedTotalAmount) + ' Rupees only');
  }, [data, totalPrice, cgstAmount, sgstAmount]);

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  const generatePDF = async () => {
    const element = printRef.current;
    const opt = {
      margin: [20, 60, 20, 60],
      filename: 'order_invoice.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: true,
        letterRendering: true
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'portrait'
      },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
        before: '.page-break'
      }
    };

    try {
      await html2pdf().set(opt).from(element).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          pdf.setFontSize(10);
          pdf.setTextColor(40, 40, 40);
          pdf.text(`Invoice #: ${data.invoice_number || ''}`, 15, 15);
          pdf.text(`Date: ${data.created_at || ''}`, 180, 15, { align: 'right' });

          pdf.text(`Page ${i} of ${totalPages}`, 105, 285, { align: 'center' });
          pdf.text(`Generated by ${companyDetails.company_name || ''}`, 15, 285);
        }
      }).save();
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  // const products = data.products || [];
  // const extrCharges = data.extrCharges || [];

  // const chunkSize = 10;
  // const productChunks = [];
  // for (let i = 0; i < products.length; i += chunkSize) {
  //   productChunks.push(products.slice(i, i + chunkSize));
  // }
  // const chunkSizesec = 20;

  // const extraChargeChunks = [];
  // for (let i = 0; i < extrCharges.length; i += chunkSizesec) {
  //   extraChargeChunks.push(extrCharges.slice(i, i + chunkSizesec));
  // }

  const products = data.products || [];
  const extrCharges = data.extrCharges || [];

  // First page shows 10 items, subsequent pages show 20 items
  const firstPageChunkSize = 10;
  const otherPagesChunkSize = 20;

  const productChunks = [];
  if (products.length > 0) {
    // First chunk (first page) - 10 items
    productChunks.push(products.slice(0, firstPageChunkSize));

    // Remaining chunks - 20 items each
    for (let i = firstPageChunkSize; i < products.length; i += otherPagesChunkSize) {
      productChunks.push(products.slice(i, i + otherPagesChunkSize));
    }
  }

  // Extra charges chunks (20 items per page)
  const extraChargeChunkSize = 20;
  const extraChargeChunks = [];
  for (let i = 0; i < extrCharges.length; i += extraChargeChunkSize) {
    extraChargeChunks.push(extrCharges.slice(i, i + extraChargeChunkSize));
  }
  const goBack = () => {
    navigate('/orderview');
  };
  return (
    <>
      <section className='orderview_section'>
        <div className="page-header">
          <div className='d-flex gap-2 justify-content-between w-100'>
            <Button type="button" className='d-flex gap-2 btn_added align-items-center' onClick={handlePrint}>
              <IoPrintSharp /> Print
            </Button>
            <Button type="button" className="btn-added" onClick={goBack}> <FaArrowLeftLong style={{ paddingRight: '3px' }} />  Back</Button>

            {/* <Button type="button" className="btn_added" onClick={generatePDF}>
              <GrDocumentPdf /> Back
            </Button> */}
          </div>
        </div>
      </section>

      <div id="pdfgen" ref={printRef} style={{

        width: '210mm',
        // width: '325mm', 
        minHeight: '267mm',
        margin: '0 auto',
        padding: '0',
        position: 'relative',
        backgroundColor: '#fff'
      }}>

        {productChunks.map((chunk, chunkIndex) => (
          <div
            key={`product-chunk-${chunkIndex}`}
            className="page-break"
            style={{
              minHeight: '267mm',
              position: 'relative',
              paddingTop: chunkIndex === 0 ? '70px' : '20px',
              marginBottom: '20px',
              border: '1px solid rgb(210, 206, 212)',
            }}
          >
            {/* Show header/footer only on first page */}
            <div className="frameimage">
              <img
                src={headerImage}
                className="imagebg"
                alt="Header"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: 'auto',
                }}
              />
              <img
                src={footerImage}
                className="imagebg1"
                alt="Footer"
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: 'auto',
                }}
              />
            </div>


            {/* Show Company & Invoice Details only on first page */}
            {chunkIndex === 0 && (
              <>
                <div
                  className="invoice-header text-center"
                  style={{
                    textAlign: 'center',
                    marginBottom: '20px',
                    borderBottom: '1px solid #eee',
                    paddingBottom: '20px',
                  }}
                >
                  <img src={logopdf} alt="Logo" />
                  <div style={{ color: '#666' }}>
                    {companyDetails.company_address || 'Company Address'},<br />
                    {companyDetails.city || 'City'}-{companyDetails.pincode || 'Pincode'},{' '}
                    {companyDetails.state || 'State'}
                    <br />
                    Phone: +91{companyDetails.mobile || 'Phone Number'}
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '30px',
                    marginLeft: '52px',
                    marginRight: '52px',
                  }}
                >
                  <div style={{ width: '48%' }}>
                    <div style={{ padding: '10px' }}>
                      <p style={{ margin: '5px 0', fontWeight: 'bold' }}>{data.customer_name || 'Customer Name'}</p>
                      <p style={{ margin: '5px 0' }}>{data.address1 || 'Address Line 1'}</p>
                      <p style={{ margin: '5px 0' }}>
                        {data.city || 'City'}-{data.pincode || 'Pincode'}, {data.state || 'State'}
                      </p>
                    </div>
                  </div>
                  <div style={{ width: '48%', textAlign: 'right' }}>
                    <div style={{ padding: '10px' }}>
                      <p style={{ margin: '5px 0' }}>
                        <strong>Invoice #:</strong> {data.invoice_number || 'N/A'}
                      </p>
                      <p style={{ margin: '5px 0' }}>
                        <strong>Date:</strong> {data.created_at || 'N/A'}
                      </p>
                      <p style={{ margin: '5px 0' }}>
                        <strong>GSTIN:</strong> {data.gst_in_no || 'N/A'}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Product Table – repeats on all pages */}
            <table
              style={{
                width: '85%',
                borderCollapse: 'collapse',
                marginBottom: '20px',
                border: '1px solid #ddd',
                marginLeft: '52px',
                position: "relative",
                zIndex: "1",
                background: "#fff"
              }}
            >
              <thead>
                <tr style={{ backgroundColor: '#527271', color: '#fff' }}>
                  <th style={{ padding: '10px', textAlign: 'left' }}>S.No</th>
                  <th style={{ padding: '10px', textAlign: 'left' }}>Description</th>
                  <th style={{ padding: '10px', textAlign: 'left' }}>HSN</th>
                  <th style={{ padding: '10px', textAlign: 'right' }}>Area</th>
                  <th style={{ padding: '10px', textAlign: 'right' }}>Price (₹)</th>
                  <th style={{ padding: '10px', textAlign: 'right' }}>Amount (₹)</th>
                </tr>
              </thead>
              <tbody>
                {chunk.map((product, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #eee' }} className="invoice-table">
                    <td style={{ padding: '10px' }}>
                      {chunkIndex === 0
                        ? index + 1 
                        : 10 + (chunkIndex - 1) * 20 + index + 1} 
                    </td>
                    <td style={{ padding: '10px', fontWeight: '600' }}>{product.name}</td>
                    <td style={{ padding: '10px' }}>{product.hsn_no || 'N/A'}</td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>{product.area_id}</td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>{product.price}</td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>
                      {(product.price * product.qty).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}

        {/* {extraChargeChunks.map((chunk, chunkIndex) => (
          <table key={chunkIndex} style={{ width: '100%', marginBottom: '30px', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5' }}>
                <th style={{ padding: '10px' }}>S.No.</th>
                <th style={{ padding: '10px' }}>Charge Title</th>
                <th style={{ padding: '10px', textAlign: 'right' }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {chunk.map((charge, index) => (
                <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px' }}>{chunkIndex * chunkSizesec + index + 1}</td>
                  <td style={{ padding: '10px' }}>{charge.title}</td>
                  <td style={{ padding: '10px', textAlign: 'right' }}>{charge.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ))} */}

        {/* {extraChargeChunks.map((chunk, chunkIndex) => (
          <div key={`extra-chunk-${chunkIndex}`} className="page-break" style={{
            minHeight: '267mm',
            position: 'relative',
            paddingTop: '70px',
            paddingBottom: '50px'
          }}>
            <div className="frameimage">
              <img src={headerImage} className="imagebg" alt="Header" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: 'auto'
              }} />
              <img src={footerImage} className="imagebg1" alt="Footer" style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
                height: 'auto'
              }} />
            </div>

            <div style={{ marginBottom: '30px' }}>
              <h3 style={{
                color: "#527271",
                borderBottom: '1px solid #527271',
                paddingBottom: '5px',
                marginBottom: '10px'
              }}>
                Extra Charges
              </h3>
              <table style={{
                width: '85%',
                borderCollapse: 'collapse',
                border: '1px solid #ddd',
                marginLeft: '52px'
              }}>
                <thead>
                  <tr style={{ backgroundColor: '#527271', color: '#fff' }}>
                    <th style={{ padding: '10px', textAlign: 'left' }}>S.No</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>Description</th>
                    <th style={{ padding: '10px', textAlign: 'right' }}>Qty</th>
                    <th style={{ padding: '10px', textAlign: 'right' }}>Rate (₹)</th>
                    <th style={{ padding: '10px', textAlign: 'right' }}>Amount (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {chunk.map((extra, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '10px' }}>{chunkIndex * chunkSize + index + 1}</td>
                      <td style={{ padding: '10px', fontWeight: '600' }}>{extra.name}</td>
                      <td style={{ padding: '10px', textAlign: 'right' }}>{extra.pro_qty}</td>
                      <td style={{ padding: '10px', textAlign: 'right' }}>{extra.price}</td>
                      <td style={{ padding: '10px', textAlign: 'right' }}>{(extra.price * extra.pro_qty)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))} */}

        {/* Final Page with Totals and Payment Info */}
        <div className="page-break" style={{
          minHeight: '270mm',
          position: 'relative',
          paddingTop: '70px',
          paddingBottom: '50px'
        }}>
          <div className="frameimage">
            <img src={headerImage} className="imagebg" alt="Header" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: 'auto'
            }} />
            <img src={footerImage} className="imagebg1" alt="Footer" style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: 'auto'
            }} />
          </div>

          {/* Company Details */}
          {/* <div className="invoice-header text-center" style={{ 
            textAlign: 'center', 
            // marginBottom: '20px',
            borderBottom: '1px solid #eee',
            // paddingBottom: '20px'
          }}>
            <img src={logopdf} alt="Logo" />
            <div style={{ color: '#666' }}>
              {companyDetails.company_address || 'Company Address'},<br />
              {companyDetails.city || 'City'}-{companyDetails.pincode || 'Pincode'}, {companyDetails.state || 'State'}<br />
              Phone: +91{companyDetails.mobile || 'Phone Number'}
            </div>
          </div> */}

          {/* Totals and Payment Info */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '52px', marginRight: '52px', marginTop: "100px" }}>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft:'52px',marginRight:'52px',marginTop:"100px"}}> */}
            <div style={{ width: '50%' }}>
              <div style={{
                backgroundColor: '#f9f9f9',
                padding: '15px',
                borderRadius: '5px',
                marginBottom: '20px'
              }}>
                <h3 style={{
                  color: "#527271",
                  borderBottom: '1px solid #527271',
                  paddingBottom: '5px',
                  marginBottom: '15px'
                }}>
                  Payment Information
                </h3>
                <p style={{ margin: '8px 0' }}>
                  <strong>Bank Name:</strong> {companyDetails.bank_name || 'N/A'}
                </p>
                <p style={{ margin: '8px 0' }}>
                  <strong>Account Name:</strong> {companyDetails.acc_holder_name || 'N/A'}
                </p>
                <p style={{ margin: '8px 0' }}>
                  <strong>Account Number:</strong> {companyDetails.account_no || 'N/A'}
                </p>
                <p style={{ margin: '8px 0' }}>
                  <strong>IFSC Code:</strong> {companyDetails.ifce_code || 'N/A'}
                </p>
                <p style={{ margin: '8px 0' }}>
                  <strong>Branch:</strong> {companyDetails.bank_address || 'N/A'}
                </p>
              </div>

              <div>
                <h3 style={{
                  color: "#527271",
                  borderBottom: '1px solid #527271',
                  paddingBottom: '5px',
                  marginBottom: '15px'
                }}>
                  Terms & Conditions
                </h3>
                <ol style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
                  <li>All disputes are subject to Jaipur jurisdiction only.</li>
                  <li>In case of cancellation, advance payment is non-refundable.</li>
                  <li>This is just an order confirmation and not an invoice or payment receipt.</li>
                  <li>Transportation, handling, and installation charges are to be paid directly by the client separately.</li>
                </ol>
              </div>
            </div>

            <div style={{ width: '45%' }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: '20px'
              }}>
                <tbody>
                  <tr>
                    <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                      <strong>Subtotal</strong>
                    </td>
                    <td style={{
                      padding: '10px',
                      textAlign: 'right',
                      borderBottom: '1px solid #eee'
                    }}>
                      ₹{totalPrice}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                      <strong>CGST ({data.c_gst || 0}%)</strong>
                    </td>
                    <td style={{
                      padding: '10px',
                      textAlign: 'right',
                      borderBottom: '1px solid #eee'
                    }}>
                      ₹{cgstAmount}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                      <strong>SGST ({data.s_gst || 0}%)</strong>
                    </td>
                    <td style={{
                      padding: '10px',
                      textAlign: 'right',
                      borderBottom: '1px solid #eee'
                    }}>
                      ₹{sgstAmount}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                      <strong>Other Charges</strong>
                    </td>
                    <td style={{
                      padding: '10px',
                      textAlign: 'right',
                      borderBottom: '1px solid #eee'
                    }}>
                      ₹{(data.other_charges_total || 0)}
                    </td>
                  </tr>
                  <tr style={{ backgroundColor: '#527271', color: '#fff' }}>
                    <td style={{ padding: '10px' }}>
                      <strong>Total Amount</strong>
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>
                      <strong>₹{data.total_amount}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="table text-dark border-dark" style={{ marginTop: '86px' }}>
                <tbody>
                  <tr>
                    <td className="border border-bottom text-end border-dark text-dark fw-bold fs-4">For  {companyDetails.company_name || 'Endless interior & Design'}</td>
                  </tr>

                  <tr>
                    <td className="text-end"><span className="text-decoration-underline text-dark fw-bold fs-4" style={{ paddingTop: "50px", display: "block" }}>Authorized Signatory</span></td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Table;